module.exports = __webpack_public_path__ + "img/Nyromantikk_Tida_og_samfunnsforholdene1.03cf69ea.jpg";